import { BehaviorSubject } from 'rxjs';
import { Message } from 'console-feed-optimized/lib/definitions/Console';

import { Service } from '../../../symphony';

import {
	IFlashMessage,
	IRouteData,
	IUpdatedCodeTemplate,
} from '../global-interface';
import { ActionTypes } from '../constants/ActionTypes';
import { IOutput } from '../../../shared/public/SlCodeEditorComponents/types/types';
import { ICodeSolution, IMaterialInfo } from '../../../api/private/learn-engine-api/learn-engine-api.interface';
import { IUserCode } from '../../../api/public/code-api';

@Service()
export class SlDataService {
	public codeData$ = new BehaviorSubject<IUserCode | IUpdatedCodeTemplate>(
		null,
	);

	public minimizedTIYEditorRefs = new BehaviorSubject(null);

	public expandedTIYEditorRefs = new BehaviorSubject(null);

	public initialCodes = new BehaviorSubject<ICodeSolution[]>(null);

	public isTIYExpanded = new BehaviorSubject<boolean>(false);

	public isTIYResetButtonActive = new BehaviorSubject<boolean>(false);

	public sourceCode$ = new BehaviorSubject<string>('');

	public cssCode$ = new BehaviorSubject<string>('');

	public jsCode$ = new BehaviorSubject<string>('');

	public output$ = new BehaviorSubject<IOutput>(null);

	public isWeb$ = new BehaviorSubject<boolean>(false);

	public isDarkMode$ = new BehaviorSubject<boolean>(true);

	public codeName$ = new BehaviorSubject<string>('');

	public inputs$ = new BehaviorSubject<string>('');

	public codeSavingActionType$ = new BehaviorSubject<ActionTypes>(
		ActionTypes.INITIAL,
	);

	public codeCompilingActionType$ = new BehaviorSubject<ActionTypes>(
		ActionTypes.INITIAL,
	);

	public flashMessage$ = new BehaviorSubject<IFlashMessage>(null);

	public topLevelDomain$ = new BehaviorSubject<string>('');

	public showConsole$ = new BehaviorSubject<boolean>(false);

	public outputConsole$ = new BehaviorSubject<Message[]>(null);

	public loading$ = new BehaviorSubject<boolean>(false);

	public isResizingPanel$ = new BehaviorSubject<boolean>(false);

	public showConfirmLeaveAlert$ = new BehaviorSubject<boolean>(false);

	public animationLoader$ = new BehaviorSubject<boolean>(false);

	public freezeLayer$ = new BehaviorSubject<boolean>(false);

	public materialData$ = new BehaviorSubject<IMaterialInfo>(null);

	public routeData$ = new BehaviorSubject<IRouteData>(null);
}
